module.exports = __webpack_public_path__ + "img/BSpearman64_ua.ab913cc3.webp";